module.exports = __webpack_public_path__ + "static/media/pr-3.c8a37437.jpg";